/**
 * Internal tools whose sessions use the short-lived token. With
 * `short_session: true` ms-login signs the token for `JWT_SHORT_EXPIRES`
 * (even while `AUTH_SLIM_SHORT_ENABLED` is off), and with that flag on it also
 * leaves the `permissions` claim out. Every other application keeps the long
 * token it gets today.
 *
 * Add an application only once it sends an expired session back to login and
 * reads permissions live instead of from the token's `permissions` claim.
 *
 * Back Office's host `backoffice.<env>.vammo.com` derives `backoffice`, while
 * ms-login keys its tables as `back-office`, so both labels are listed.
 */
const SHORT_SESSION_APPLICATIONS = new Set(["maestro", "backoffice", "back-office", "torrevammo", "coupons-dashboard", "bluedots"]);

export const usesShortSession = (application: string): boolean =>
  SHORT_SESSION_APPLICATIONS.has(application);

export type GoogleLoginBody = {
  type: "GOOGLE";
  google_token: string;
  source: "auth_core";
  short_session?: true;
};

/** The `/v2/login` body. Apps outside the set get exactly the body they got before. */
export const googleLoginBody = (
  googleToken: string,
  application: string
): GoogleLoginBody => ({
  type: "GOOGLE",
  google_token: googleToken,
  source: "auth_core",
  ...(usesShortSession(application) ? { short_session: true } : {}),
});
